// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"048cf127","498":"8e7a2f2c","616":"ee8c8d76"}[chunkId] + ".chunk.js";
};